import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonCircle } from './Button';
import { Opener } from './Opener';
import { Select } from './Select';
import { Icon } from './Icon';

import styles from './customerSelect/customerSelect.module.scss';

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
    };
  }

  onError = () => this.setState({ isError: true });

  render() {
    const { src, name } = this.props;
    const { isError } = this.state;

    return !isError ? (
      <img
        src={src}
        alt=""
        onError={this.onError}
      />
    ) : (
      <div className={styles.noImage}>
        {name[0]}
      </div>
    );
  }
}

export class CustomerSelect extends Component {
  getToggleContent = (func) => {
    this.toggleOpener = func;
  };

  closeOpener = () => this.toggleOpener(false);

  renderOption = (option) => {
    const {
      label,
      value,
      email,
      image,
    } = option;

    return ({
      label,
      value,
      email,
      image,
      reactLabel: (
        <div className={styles.option}>
          <div className={styles.image} key={`${value}-image`}>
            <Image src={image} name={label} />
          </div>
          <div className={styles.info} key={`${value}-info`}>
            <div className={styles.label} key={`${value}-name`}>
              {label}
            </div>
            <div className={styles.email} key={`${value}-email`}>
              {email}
            </div>
          </div>
          <div className={styles.id} key={`${value}-id`}>
            <div className={styles.idLabel} key={`${value}-id-title`}>
              ID
            </div>
            <div className={styles.idValue} key={`${value}-id-value`}>
              {value}
            </div>
          </div>
        </div>
      ),
    });
  };

  transformedOptions = (options) => options.map(this.renderOption);

  renderBtn = () => {
    const { value, balance } = this.props;

    return !value ? (
      <ButtonCircle
        outline
        iconName="People"
        className="_size-24"
      />
    ) : (
      <div className={`${styles.option} ${styles._selected}`}>
        <i className={styles.icon}>
          <Icon name="People" />
        </i>
        <div className={styles.info}>
          <div className={styles.label}>
            {value.label}
          </div>
          <div className={styles.email}>
            {value.email}
          </div>
        </div>
        {balance ? (
          <div className={styles.balance}>
            <div className={styles.balanceLabel}>
              Balance
            </div>
            <div className={styles.balanceValue}>
              {balance}
            </div>
          </div>
        ) : null}
        <div className={styles.image}>
          <Image src={value.image} name={value.label} />
        </div>
      </div>
    );
  }

  renderList = () => {
    const {
      className = '',
      options,
      value,
      onChange,
      selectSpecificProps,
      isSimpleBtn,
    } = this.props;

    const classNames = [styles.select];
    if (isSimpleBtn && className) {
      classNames.push(className);
    }

    return (
      <Select
        className={classNames.join(' ')}
        isAlwaysOpen={!isSimpleBtn}
        btnOnClick={!isSimpleBtn ? this.closeOpener : null}
        options={this.transformedOptions(options)}
        value={value}
        isSearchable
        isClearable
        onChange={onChange}
        placeholder="Select Customer"
        {...selectSpecificProps}
      />
    );
  }

  render() {
    const { className = '', value, isSimpleBtn } = this.props;

    return !isSimpleBtn ? (
      <Opener
        className={`${styles.opener} ${className}`}
        contentClassName={`${styles.content} ${value ? styles._selected : ''}`}
        getToggleContent={this.getToggleContent}
        btn={this.renderBtn()}
        content={this.renderList()}
      />
    ) : this.renderList();
  }
}

CustomerSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  balance: PropTypes.string,
  selectSpecificProps: PropTypes.object,
  isSimpleBtn: PropTypes.bool,
};
